import { render, staticRenderFns } from "./cinema-staff-form.vue?vue&type=template&id=606a9ac6&"
import script from "./cinema-staff-form.vue?vue&type=script&lang=ts&"
export * from "./cinema-staff-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports